<template>
    <Widget title="Alerts"
        :headerLink="isStandardUser ? 'alerts' : null"
    >
        <template v-slot:icon>
            <i class="fas fa-exclamation-triangle" style="font-size:30px; color: #036"></i>
        </template>

        <div class="d-flex flex-column">
            <div class="d-flex justify-content-between">
                <button v-show="isStandardUser" class="btn btn-sm btn-light" @click="goToAlertsPage">
                    <i class="fas fa-list-ul"></i>
                    Alert List
                </button>

                <button type="button" class="btn btn-sm btn-light" @click="stopActiveAlerts">
                    <i class="fa fa-stop fa-fw" aria-hidden="true"></i>
                    Stop Active
                </button>
            </div>

            <Alerts />
        </div>
    </Widget>
</template>

<script>
import { mapGetters } from 'vuex'
import Widget from '../Widget.vue';
import Alerts from './Alerts.vue';
import router from '../../../router';

export default {
    components: { Alerts, Widget },
    computed: {
        ...mapGetters({
            is_authenticated: 'isAuthenticated',
            logged_in_user: 'loggedInUser',
        }),
        isStandardUser() {
            return this.is_authenticated && [1,2,3,4].includes(this.logged_in_user.group_id)
        }
    },
    methods: {
        goToAlertsPage() {
            router.push('alerts')
        },
        stopActiveAlerts() {
            this.g2dialog.$confirm('You are about to stop active alerts. Continue?')
                .then((confirmed) => confirmed && this.$store.dispatch('stopActiveAlerts'))
        }
    }
}
</script>